<template>
  <apexchart ref="chart" type="bar" height="320" :options="options" :series="series"/>
</template>

<script>
export default {
  name:'GFOutgoingMembersBar',
  props:{ periods:Array, outgoingCounts:Array, paidAmountsCr:Array },
  computed:{
    series(){
      return [
        { name:'No. of Outgoing Members', data:this.outgoingCounts },
        { name:'Amount paid', data:this.paidAmountsCr }
      ];
    },
    options(){
      return {
        chart:{ id: 'gf-outgoing-members', stacked:false, toolbar:{ show:false, tools: {download: false, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false} }},
        plotOptions:{ bar:{ columnWidth:'40%', borderRadius:4 }},
        dataLabels:{ enabled:false },
        xaxis:{ categories:this.periods },
        yaxis: [
            {
              seriesName: 'No. of Outgoing Members',
              axisTicks: { show: true },
              axisBorder: { show: true, color: '#01524b' },
              labels: { style: { colors: '#01524b' }, formatter: v => Math.round(v) },
              title: { text: 'No. of Outgoing Members', style: { color: '#01524b' } }
          },
          {
              seriesName: 'Amount paid',
              opposite: true,
              axisTicks: { show: true },
              axisBorder: { show: true, color: '#8fd8d0' },
              labels: { style: { colors: '#8fd8d0' }, formatter: v => this.fmt(v) },
              title: { text: 'Amount Paid', style: { color: '#8fd8d0' } }
          }
        ],
        legend:{ position:'bottom' },
        tooltip:{
          shared: true,
          intersect: false,
          y: {
            formatter: (v, { seriesIndex }) =>
              seriesIndex === 1 ? `${v.toFixed(2)}` : `${v}`
          }
        },
        colors: [
          '#01524b',
          '#8fd8d0',
        ],
      };
    }
  },
  methods: {
    fmt(v) {
      if (v === null || v === undefined || isNaN(v)) return '';
      return Number(v).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    },
    exportPng(filename = 'Outgoing_Members_Paid_Amount_GF.png') {
      const comp = this.$refs.chart;
      if (!comp || !comp.chart) {
        console.error('ApexCharts instance not ready');
        return;
      }
      comp.chart.dataURI().then(({ imgURI }) => {
        const a = document.createElement('a');
        a.href = imgURI;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }).catch(err => {
        console.error('Failed to export chart image:', err);
      });
    }
  }
};
</script>
